import React, { useState, useRef, useEffect } from "react";
import { Box, Typography, Backdrop } from "@mui/material";

const FileDropHandler = ({ onFileUpload, children }) => {
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handlePaste = (e) => {
    try {
      const clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      if (clipboardData.files?.length) {
        const fileList = Array.from(clipboardData.files);
        if (fileList.length) {
          e.preventDefault();
          onFileUpload(fileList.length === 1 ? fileList[0] : fileList);
        }
      }
    } catch (error) {
      console.error("Erro no handlePaste:", error);
    }
  };   

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    if (!containerRef.current.contains(event.target)) {
      setIsDragging(false);
    }
  };

  const handleDrop = (event) => {
    try {
      event.preventDefault();
      setIsDragging(false);

      const dataTransfer = event.dataTransfer;
      if (!dataTransfer || !dataTransfer.files) return; // Valida a existência de files

      const files = Array.from(dataTransfer.files);
      if (files.length > 0) {
        onFileUpload(files.length === 1 ? files[0] : files);
      }
    } catch (error) {
      console.error("Erro ao processar o evento de arrastar e soltar:", error);
    }
  };

  useEffect(() => {
    document.addEventListener("paste", handlePaste);
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      {children}
      <Backdrop
        open={isDragging}
        sx={{
          zIndex: 13000,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Solte os arquivos para anexar</Typography>
      </Backdrop>
    </Box>
  );
};

export default FileDropHandler;
